import { render } from "./AboutComponent.vue?vue&type=template&id=c5677162&scoped=true"
const script = {}

import "./AboutComponent.vue?vue&type=style&index=0&id=c5677162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5677162"]])

export default __exports__